"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextareaInput = function TextareaInput(props) {
  var label = props.label || (0, _utils.capitalizeFirstLetter)(props.name),
      placeholder = "".concat(props.t('Enter a value for'), ": ").concat(label),
      hasError = props.errors ? props.errors[props.name] : false,
      error;

  if (hasError) {
    error = props.errors[props.name].map(function (errorMsg) {
      return props.t(errorMsg);
    }).join(', ');
  }

  return /*#__PURE__*/_react.default.createElement("label", {
    className: "input ".concat(hasError ? 'error' : '', " ").concat(props.readOnly ? 'read-only' : '')
  }, label, /*#__PURE__*/_react.default.createElement("span", {
    className: "input__wrapper"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    name: props.name,
    value: props.value || '',
    placeholder: placeholder,
    readOnly: props.readOnly,
    onChange: props.onChange
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "input__error"
  }, error));
};

TextareaInput.defaultProps = {
  readOnly: false
};
TextareaInput.propTypes = {
  t: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  errors: _propTypes.default.any
};
var _default = TextareaInput;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/textarea.js
// module id = 509
// module chunks = 0